import { displayDateWithoutTime, getHoursWithoutMinutes } from 'lib/util/date'
import BillingModal from './billing-modal'
import { useState } from 'react'
import { Calendar } from 'lucide-react'
import { useBillingPlans } from './billing-plans-context'
import { Company } from 'interfaces/company'

const classNames = {
  cardItem: 'tw-mb-4 tw-flex tw-items-center tw-justify-between',
  cardWrapper: 'tw-w-full tw-p-4 tw-block tw-overflow-x-auto tw-bg-white tw-rounded-lg tw-shadow-md tw-h-56',
}

export default function BillingYourSubscription({ company }: { company: Company }) {
  const [openModal, setOpenModal] = useState(false)
  const { currentPlans } = useBillingPlans()
  const { platformPlan, creativePlan, professionalPlan } = currentPlans
  const nextBillingDate = platformPlan ? displayDateWithoutTime(company.nextBillingDate) : 'N/A'

  return (
    <>
      <div className={classNames.cardWrapper}>
        <div className={classNames.cardItem}>
          <strong>Your Subscription</strong>
          <div
            onClick={() => setOpenModal(true)}
            className="tw-text-squash-600 tw-cursor-pointer tw-text-cornflower-500 hover:tw-underline"
          >
            Manage subscription
          </div>
        </div>
        <div className={classNames.cardItem}>
          <div>Platform</div>
          <div data-testid="platform">{platformPlan ? platformPlan?.name : 'Not subscribed'}</div>
        </div>
        <div className={classNames.cardItem}>
          <div>Creative services</div>
          <div data-testid="creative-services">{`${getHoursWithoutMinutes(creativePlan ? creativePlan?.dailyTime : 0)} (daily)`}</div>
        </div>
        <div className={classNames.cardItem}>
          <div>Professional services</div>
          <div data-testid="professional-services">{professionalPlan ? 'Enabled' : 'Disabled'}</div>
        </div>
        <div className="tw-border-b tw-border-solid tw-border-peppercorn-50" />
        <div className="tw-mt-4 tw-flex tw-items-center tw-justify-center">
          <Calendar className="tw-mr-2" />
          {`Next billing date: ${nextBillingDate}`}
        </div>
      </div>
      <BillingModal open={openModal} setOpen={setOpenModal} />
    </>
  )
}
